import { render, staticRenderFns } from "./Anwesenheiten.vue?vue&type=template&id=5449fb5a&scoped=true"
import script from "./Anwesenheiten.vue?vue&type=script&lang=ts"
export * from "./Anwesenheiten.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449fb5a",
  null
  
)

export default component.exports